import uiUxPoster from "../../../images/internships/ui-ux.png";
import webDevPoster from "../../../images/internships/web-dev.png";
import appDevPoster from "../../../images/internships/app-dev.png";
import digitalMarketingPoster from "../../../images/internships/digital-marketing.png";

const InternshipData = [
  { url: "/", imgUrl: uiUxPoster, title: "UI / UX Internship" },
  { url: "/", imgUrl: webDevPoster, title: "Web Development Internship" },
  { url: "/", imgUrl: appDevPoster, title: "App Development Internship" },
  {
    url: "/",
    imgUrl: digitalMarketingPoster,
    title: "Digital Marketing Internship",
  },
  { url: "/", imgUrl: uiUxPoster, title: "This is a text Internship" },
];

export default InternshipData;
